<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    Wepay Log
                </div>


                <div class="row search-section">
                    <div class="col-sm-1 col-search">



                    </div>

                    <div class="col-sm-3 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอก uid เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-4 col-search" style="display: flex;">
                        <date-picker v-model="start_date" format="DD-MM-YYYY" placeholder="วันเริ่มต้น" />
                        <div style="width: 30px;">-</div>
                        <date-picker v-model="end_date" format="DD-MM-YYYY" placeholder="วันสิ้นสุด" />
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>

                <div class="body table-responsive" style="width:100%">
                    <div class="row">
                        <div class="col-sm-6" style="text-align: left;">
                            <div class="p-title">แสดงรายการระหว่าง วันที่ {{ start_date_text }} - {{ end_date_text }}
                            </div>
                        </div>
                        <div class="col-sm-5"> </div>
                        <div class="col-sm-1" style="text-align: right;">
                            <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;"
                                @click="download()" />
                        </div>
                    </div>
                  
                     <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนชำระเงินทั้งหมด:</b> {{ total | comma }} ครั้ง
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนชำระเงินสำเร็จ:</b> <span style="color:green">{{ total_success | comma }} </span>ครั้ง
                        </div>
                    </div>

                     <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนชำระเงินไม่สำเร็จ:</b> <span style="color:red">{{ (total - total_success) | comma }}</span> ครั้ง
                        </div>
                    </div>
                   

                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>

                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th" >member</th>
                                    <th class="fn-th" >uid</th>
                                    <th class="fn-th" >package</th>
                                    <th class="fn-th">dest_ref</th>
                                    <th class="fn-th">transaction_id</th>
                                    <th class="fn-th" style="width: 300px;">sms</th>
                                    <!-- <th class="fn-th">operator_trxnsid</th> -->
                                    <th class="fn-th" style="width: 200px;">สถานะ</th>
                                    <th class="fn-th">เวลาที่สร้าง</th>
                                    <th class="fn-th">เวลาที่ตอบกลับ</th>
                                 

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.uid + '-' + index"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page - 1) * perpage) + index + 1"></td>

                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.uid }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.dest_ref }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.transaction_id }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.sms }}</span>
                                    </td>
                                   
                                    <td style="text-align: center;">
                                        
                                         <span style='color: green;' v-if="item.status == 2">สำเร็จ</span>  
                                        <span style='color: red;' v-else>ล้มเหลว</span>
                                        
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.created_at | date }} </span>
                                    </td>

                                     <td style="text-align: center;">
                                        <span>{{ item.callback_at | date }} </span>
                                    </td>
                                   
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>

    </section>
</template>

<script>
import WepayService from '../../service/WepayService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import Paginate from 'vuejs-paginate'


export default {
    name: "WepayLog",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            date: localStorage.getItem('date'),
            page: 1,
            perpage: 50,
            total: 0,
            total_success: 0,
            pages: 0,
            items: [],
            key: "",
            file: null,
            searching: false,
            loading: false,
            start_date: null,
            start_date_text: "",
            end_date_text: "",
            end_date: null,
            search_params: {}
        }
    },
    async created() {
        this.start_date = new Date(this.date)
        this.end_date = new Date(this.date)

        this.search(1)
    },
    mounted() {

    },
    watch: {
        start_date(val) {
            this.end_date = val
        }
    },
    methods: {

        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            this.start_date_text = moment(this.start_date).format('DD/MM/YYYY')
            this.end_date_text = moment(this.end_date).format('DD/MM/YYYY')

            let response = await WepayService.search(this.key, this.page, this.perpage, start_date, end_date)
            console.log(response)
            if (response.status) {
                let { page, perpage, total, total_success, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages) 
                this.items = data
                this.total_success = total_success

            }
            this.loading = false
        },
        reset() {
            this.key = ""
            this.start_date = new Date(this.date)
            this.end_date = new Date(this.date)
            this.search(1)
        },
           download(){
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            let url = `${process.env.API2}/export/wepay/log`
            let fileName = 'wepaylog_' + moment().format('YYYYMMDD_HHmmss') +'.xlsx'
           
            let request = new XMLHttpRequest();
            request.onload = function(e) {
                if (this.status === 200) {
                    
                        let blob = this.response;
                        if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, fileName);
                            
                        }
                        else{
                            let downloadLink = window.document.createElement('a');
                            let contentTypeHeader = request.getResponseHeader("Content-Type");
                            downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }));
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            
                        }
                    
                }
                else{
                    alertBox.error("Error ,Can not download")
                    
                }
               
            };
            
            request.open('POST', url);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.withCredentials = true;
            request.responseType = 'blob';
            request.send(`searchKey=${this.key}&startDate=${start_date}&endDate=${end_date}`);
        },

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma(value, 2)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm:ss')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Manage/WepayLog.vue